import { AttackPattern, PatternState } from '../AttackPattern.js';

/**
 * Implosion — the boss breathes out a ring of projectiles that fly outward
 * across the arena, then curve back and get sucked into the boss. Reuses
 * BossBullet's homing (target = the boss itself, which only needs `.x/.y`):
 * each bullet launches radially outward but steers toward the boss, so it arcs
 * out and comes back in, sweeping the arena twice — once leaving, once
 * returning. Unlocks at phase 1.
 *
 * `config` (count/damage/speed) is per-boss tuning, supplied by data/bosses.js.
 */
export class Implosion extends AttackPattern {
  constructor({ minPhase = 1, config }) {
    super({ name: 'Implosion', telegraphDuration: 0.8, activeDuration: 0.2, minPhase });
    this.config = config;
  }

  onActiveStart(boss, player, pool) {
    const { count, damage, speed } = this.config;
    for (let i = 0; i < count; i++) {
      const angle = (i / count) * Math.PI * 2;
      // Spawn just outside the boss so the outward heading is well-defined,
      // then home back toward the boss — the "suck in" arc.
      pool.fire({
        x: boss.x + Math.cos(angle) * (boss.radius + 4),
        y: boss.y + Math.sin(angle) * (boss.radius + 4),
        vx: Math.cos(angle) * speed,
        vy: Math.sin(angle) * speed,
        radius: 3,
        damage,
        color: '#ffd166',
        lifetime: 4,
        homing: true,
        turnRate: 2.2,
        target: boss,
      });
    }
  }

  getVisual(boss) {
    if (this.state !== PatternState.TELEGRAPH) return null;
    return { kind: 'implosionPreview', x: boss.x, y: boss.y, count: this.config.count, color: '#ffd166' };
  }
}
